import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyAPW-CdFthTPFJy50j7VxeYUDOUvESYCZo',
  authDomain: 'mypage-20f7d.firebaseapp.com',
  projectId: 'mypage-20f7d',
  storageBucket: 'mypage-20f7d.appspot.com',
  messagingSenderId: '120211029407',
  appId: '1:120211029407:web:13f74017d41c8da52411aa',
  measurementId: 'G-X8NC8DQE9H',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
